export default __webpack_public_path__ + "static/media/bg.cf554b3d.jpg";